import { a as m } from "./query-24926cff-3eb94bfb.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function f(t) {
  return function (u, i) {
    var _ref = t != null ? t : {},
      n = _ref.slot,
      e = _ref.selector,
      c = "slot" + (n ? "[name=".concat(n, "]") : ":not([name])");
    return m(u, i, {
      get: function get() {
        var o, r;
        var l = (o = this.renderRoot) == null ? void 0 : o.querySelector(c),
          s = (r = l == null ? void 0 : l.assignedElements(t)) != null ? r : [];
        return e === void 0 ? s : s.filter(function (a) {
          return a.matches(e);
        });
      }
    });
  };
}
export { f };